import type { ItemsType } from "../../../common-deprecated/redux/typeHelpers";
import type { FetchSpecsEquipmentDataType } from "../server/data/FetchSpecifications";
import type { CommonSettingsType } from "../../../common-deprecated/settings/fetchCommonSettings";
import { getAPI } from "../../../common-deprecated/settings/utils/commonSettingUtils";
import type { FinanceOptionType } from "../../../common-deprecated/types/CommonTypes";
import type { FetchTechSpecAndEquipmentBodyType } from "../../../common-deprecated/types/SpecTypes";
import type { BasketType } from "../types/BasketType";
import type { CarType } from "../types/CarType";
import { getEcoTagType, getExternalConfigOptionsAccessoryIdsDeprecated } from "./typedUtils";

export const getTechSpecsAndEquipmentBody = (
    car: CarType,
    basket: BasketType,
    items: ItemsType,
    financeOption: FinanceOptionType,
): FetchTechSpecAndEquipmentBodyType => {
    const carShortId = car.shortId;
    const colourCode = basket.colour.internalCode;
    const upholsteryCode = basket.upholstery.internalCode;

    const { options, accessories } = getExternalConfigOptionsAccessoryIdsDeprecated(basket, items, true, true);

    const packs = basket.packs.filter((item) => !item.standard).map((item) => item.shortId);
    const serviceProducts = basket.serviceProducts.map((serviceProduct) => serviceProduct.shortId);

    if (financeOption === "monthly") {
        if (basket.financePacks.length > 0) {
            packs.push(...basket.financePacks.map((pack) => pack.shortId));
        }
        if (basket.financePackServiceProducts.length > 0) {
            serviceProducts.push(...basket.financePackServiceProducts.map((serviceProduct) => serviceProduct.shortId));
        }
        if (basket.financePackExtras.length > 0) {
            options.push(
                ...basket.financePackExtras.filter((extra) => extra.type === "option").map((option) => option.shortId),
            );
            accessories.push(
                ...basket.financePackExtras
                    .filter((extra) => extra.type === "accessory")
                    .map((accesory) => accesory.shortId),
            );
        }
    }

    return {
        model: car.model.id || "",
        car: car.id || "",
        modelCode: car.model.internalCode || "",
        certification: car.certification,
        ecoTag: getEcoTagType(car.motorization.engine),
        carShortId,
        colourCode,
        upholsteryCode,
        packs,
        serviceProducts,
        options,
        accessories,
    };
};

export async function loadTechSpecs(
    commonSettings: CommonSettingsType,
    car: CarType,
    basket: BasketType,
    items: ItemsType,
    financeOption: FinanceOptionType,
): Promise<FetchSpecsEquipmentDataType> {
    const body = getTechSpecsAndEquipmentBody(car, basket, items, financeOption);
    const fetchSpecs = await fetch(getAPI(commonSettings, "specs"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    const result = await fetchSpecs.json();
    return result;
}
